import React, { useState } from "react";
import { AppLayout } from "@amzn/awsui-components-react-v3/polaris";
import { DefaultSideNavigation } from "./side-navigation";
import TopNavigation from "./top-navigation";
import {
  isAuthedUserAdmin,
  isAuthedUserManager,
  isOtpEnabledForAuthedUser,
} from "../utils/permissions";
import { AuthContextProps } from "react-oidc-context";
import { logOutOfIdp } from "../utils/logout/logout";

interface PageLayoutProps {
  children: React.ReactNode;
  sideNav?: React.ReactNode;
  auth: AuthContextProps;
  /** When disableNavigation is true, UI elements that handle navigation to other pages (side navigation and search bar) will be hidden */
  disableNavigation?: boolean;
  sideNavOpen?: boolean;
  tools?: React.ReactNode;
  toolsOpen?: boolean;
  onToolsChange?: (open: boolean) => void;
  maxContentWidth?: number;
  title?: string;
}

export const PageLayout = (props: PageLayoutProps) => {
  const [navigationOpen, setNavigationOpen] = useState(
    props.sideNavOpen ?? true,
  );
  const isManager = isAuthedUserManager(props.auth);
  const otpEnabled = isOtpEnabledForAuthedUser(props.auth);
  const isAdmin = isAuthedUserAdmin(props.auth);

  return (
    <>
      <TopNavigation
        loggedInAlias={props.auth.user?.profile?.preferred_username}
        loggedInUsername={props.auth.user?.profile?.name}
        logout={async () => {
          logOutOfIdp({ auth: props.auth });
        }}
        showSearch={isAdmin && !props.disableNavigation}
        title={props.title}
      />
      <AppLayout
        content={props.children}
        navigationHide={props.disableNavigation}
        navigation={
          props.sideNav ?? (
            <DefaultSideNavigation
              otpEnabled={otpEnabled}
              isManager={isManager}
            />
          )
        }
        navigationOpen={navigationOpen}
        onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
        tools={props.tools}
        toolsOpen={props.toolsOpen}
        onToolsChange={({ detail }) => props.onToolsChange?.(detail.open)}
        toolsHide={!props.tools}
        headerVariant="high-contrast"
        maxContentWidth={props.maxContentWidth ?? 1350}
      />
    </>
  );
};
